import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react"
import { ButtonListTiny } from "./ButtonListTiny";
import { Strings } from "../Stores/StringsStore";

@observer
export class EditButtonListTiny extends ButtonListTiny {

	@computed get classNames() {
		switch (this.props.switchState) {
			case 0:
				return "type-edit-bg-1";
			default:
				return "type-edit-bg-1";
		}
	}

  render() {
		return <ButtonListTiny {...this.props} title={this.props.title ? this.props.title : Strings.general.editButtonTooltip}>
			<i className={this.classNames} />
		</ButtonListTiny>;
  }
}
